import {NameAndDescription} from './NameAndDescription';

export class Drinks {
    constructor(public drinks: NameAndDescription[]) {
    }
}
